import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';
import { openDraftInStudio } from '../Connections/introspection';

/**
 * "Confirm for everyone" (#1174 §7): after the asker said a metric means what they were shown, a person who may
 * confirm its draft gets a button to Studio's confirmation screen (C3) for it. The chat yes confirmed nothing: the
 * confirmation is made there, with the evidence in view, and checked by the server again.
 */
export default function ConfirmForEveryone({ turn }: { turn: LandingAgentTurn }) {
  const links = turn.confirmForEveryone || [];
  if (!links.length) return null;
  return (
    <Box data-testid="confirm-for-everyone" sx={{ display: 'grid', gap: 0.75 }}>
      {links.map((l) => (
        <Box key={l.metric} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="body2" color="text.secondary">
            {`Only you have accepted ${l.label}. It is still unconfirmed for everyone else.`}
          </Typography>
          <Button size="small" variant="outlined" onClick={() => void openDraftInStudio(l.draft_id, l.ref)}>
            Confirm for everyone
          </Button>
        </Box>
      ))}
    </Box>
  );
}
